import { useCallback } from "react";
import { useField } from "formik";

export const CustomFormField = ({ name, children, ...rest }) => {
  const [field, meta, helpers] = useField({ name });

  const handleChange = useCallback((value) => {
    helpers.setValue(value);
    // Reference: https://github.com/formium/formik/issues/2982
    // When using the useField hook, the functions returned in the 3rd element of the tuple,
    // (i.e. setValue, setTouched and setError) are referentially different on each render.
    //
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return typeof children === "function"
    ? children({
        field: { ...rest, ...field, onChange: handleChange },
        meta,
        helpers,
      })
    : children;
};
